import { Injectable } from "@angular/core";
import { SearchMerchant } from "@app/models/merchant/SearchMerchant";
import { MerchantListingEndpoint } from "@app/services/merchant/merchant-listing/merchant-listing-endpoint.service";


@Injectable()
export class MerchantListingService{

    constructor(private merchantListingEndpoint: MerchantListingEndpoint){}

    getMerchantListingDetails(searchMerchantModel:SearchMerchant) {
        return this.merchantListingEndpoint.getMerchantListingDetails(searchMerchantModel);
    }
   
}


// WEBPACK FOOTER //
// ./src/app/services/merchant/merchant-listing/merchant-listing.service.ts